import { BaseState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'

export enum AttachmentType {
  Headshot = 'head_shot',
  Identification = 'identification'
}

export interface Attachment {
  type: SohoModel.Attachment
  id: string
  url: string,
  attachmentType: AttachmentType
}

export type AttachmentResource = JsonApi.ResourceObject<Attachment>

export type AttachmentsState = BaseState<AttachmentResource>
